// Restore shareable report filters without changing API defaults or field types.
export const readReportFilters = (params, defaults) => {
  const filters = { ...defaults };
  Object.entries(defaults).forEach(([key, fallback]) => {
    const value = params.get(key);
    if (value === null) return;
    if (typeof fallback === "boolean") {
      if (value === "true" || value === "false") filters[key] = value === "true";
    } else if (typeof fallback === "number") {
      const number = Number(value);
      if (Number.isInteger(number) && number > 0) filters[key] = number;
    } else {
      filters[key] = value;
    }
  });
  return filters;
};

export const writeReportFilters = (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  });
  return params;
};

export const isCapturedWithoutConfirmedOrder = (row) =>
  String(row.status || "").toLowerCase() === "captured" && row.orderConfirmed === false;